import PhatInput from 'components/formElements/PhatInput'
import React, { useState } from 'react'

import { ExporterProps } from 'components/deckPage/modals/Export/types'
import { generatePDFFile, SortMethod } from './helper'

import PhatButton from 'components/formElements/PhatButton'

import styles from './pdfFile.module.scss'
import genericStyles from 'components/deckPage/modals/Export/generic.module.scss'
import ToastService from 'services/toast.service'
import PhatDropdown from 'components/formElements/PhatDropdown'

const PDFFile = ({ selectedCards, categoryMap, fileName = 'archidekt_export' }: ExporterProps) => {
  const [deckName, setDeckName] = useState(fileName)
  const [date, setDate] = useState('')
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [designer, setDesigner] = useState('')
  const [dci, setDci] = useState('')
  const [location, setLocation] = useState('')
  const [event, setEvent] = useState('')

  const [sortMethod, setSortMethod] = useState<SortMethod>('alpha')

  const [loading, setLoading] = useState(false)

  const handleDownload = (e: React.FormEvent) => {
    e.preventDefault()

    setLoading(true)

    generatePDFFile(
      selectedCards,
      categoryMap,
      sortMethod,
      deckName,
      date,
      firstName,
      lastName,
      designer,
      dci,
      location,
      event,
    )
      .catch(() => ToastService.create('Failed to generate PDF', 'Deck export', 'error'))
      .finally(() => setLoading(false))
  }

  return (
    <form onSubmit={handleDownload} className={styles.form}>
      <div className={styles.row}>
        <PhatInput
          header="Deck name"
          placeholder="My super awesome deck"
          value={deckName}
          onChange={setDeckName}
          name="Deck name"
        />
        <PhatInput
          header="Date"
          onChange={setDate}
          placeholder="08/15/2024"
          containerClassName={styles.date}
          name="date"
        />
      </div>

      <div className={styles.row}>
        <PhatInput
          header="First name"
          onChange={(_e: any, data: any) => setFirstName(data.value)}
          placeholder="Tony"
          name="First name"
        />
        <PhatInput header="Last name" value={lastName} onChange={setLastName} placeholder="Tiger" name="Last name" />
        <PhatInput header="Designer" onChange={setDesigner} placeholder="FlakeyTiger22" />
      </div>

      <div className={styles.row}>
        <PhatInput header="DCI #" onChange={setDci} placeholder="22299933311" />
        <PhatInput header="Location" onChange={setLocation} placeholder="LVCC - Hall G - Table 12" />
        <PhatInput header="Event name" onChange={setEvent} placeholder="Grand Prix Las Vegas 2024 - Modern" />
      </div>

      <PhatDropdown
        value={sortMethod}
        inlineHeader
        header="Sort by"
        options={[
          { id: 'alpha', label: 'Alphabetical', onClick: () => setSortMethod('alpha') },
          { id: 'manaValue', label: 'Mana value', onClick: () => setSortMethod('manaValue') },
          { id: 'color', label: 'Color', onClick: () => setSortMethod('color') },
          { id: 'type', label: 'Type', onClick: () => setSortMethod('type') },
        ]}
      />

      <div className={genericStyles.controls}>
        <PhatButton color="green" icon="download" type="submit" disabled={loading}>
          {loading ? 'Generating PDF...' : 'Download PDF'}
        </PhatButton>
      </div>
    </form>
  )
}

export default PDFFile
